import "core-js/modules/es.array.push.js";
import { mapState } from 'vuex';
import Cookie from 'js-cookie';
import { handleLocalStorage, getTheme, setTheme } from '@/assets/js/utils.js';
export default {
  data() {
    return {
      applicationName: handleLocalStorage('get', 'applicationName'),
      fontVersion: '',
      backendVersion: '',
      showRightPop: false,
      selectType: 'invitedOther',
      collaborateInfo: {
        show: false,
        title: '',
        save: 'invite.saveInvite',
        hideCancel: true,
        hideBottom: true
      },
      collaboratePageInfo: {
        pageNum: 1,
        pageSize: 5,
        hasNextPage: false
      },
      receiverCollaboratePageInfo: {
        pageNum: 1,
        pageSize: 5,
        hasNextPage: false
      },
      willInviteCollaborate: [],
      hadInviteCollaborate: [],
      hadInvite: [],
      invitedMeList: [],
      tabList: [],
      showErrorEmailText: false,
      collaborateSearchName: '',
      collaborateScroll: {
        distance: 10,
        onScroll: this.getCollaborateHadInvite
      },
      receiverCollaborateScroll: {
        distance: 10,
        onScroll: this.getInvitedByOhter,
        directive: '.invitedMe .el-table__body-wrapper'
      },
      options: [{
        value: '1',
        label: 'accept'
      }, {
        value: '2',
        label: 'decline'
      }],
      inputTimer: null,
      hadInviteUserColor: ['green', 'orange', 'purple', 'blue'],
      currentModule: 'party',
      mouseArray: {},
      logoSvg: ''
    };
  },
  setup() {
    const {
      isDark
    } = getTheme();
    // const { x, y } = useMove((info) => {
    //   return info
    // })
    return {
      isDark,
      getTheme,
      setTheme
    };
  },
  async created() {
    document.title = this.$t('common.partylineManage');
    // 获取前端版本号
    let fontEndVersionStr = handleLocalStorage('get', 'partylineVersion');
    if (fontEndVersionStr && fontEndVersionStr.includes('_')) {
      fontEndVersionStr = fontEndVersionStr.substring(0, fontEndVersionStr.indexOf('_'));
    }
    this.fontVersion = fontEndVersionStr;
    // 获取后台版本号
    this.getBackendVersion();
    this.getCollaborateHadInvite('init');
    const config = JSON.parse(handleLocalStorage('get', 'partylineConfig'));
    if (config && config.mode) {
      Object.keys(config.mode).forEach(k => {
        // 为了 kiosk global control 特意加的
        if (config.mode[k] && this.tabConfig[k]) {
          this.tabList.push(this.tabConfig[k]);
        }
      });
    }
    // 页面创建 ws
    Bus.$emit('createWs', {
      ...this.State.config,
      partyCode: '746933411446'
    });
    Bus.$on('notify', v => {
      const {
        key,
        position,
        id,
        email,
        screenWidth,
        screenHeight
      } = v;
      if (key === 'mousePosition' && id && id != this.State.loginInfo.id) {
        position.x = (window.screen.width / screenWidth * position.x).toFixed(2);
        position.y = (window.screen.height / screenHeight * position.y).toFixed(2);
        this.$set(this.mouseArray, id, {
          ...position,
          email
        });
      }
    });
  },
  mounted() {
    this.logoSvg = `#${this.State.commonLogo}`;
  },
  computed: {
    ...mapState({
      State: state => state,
      config: state => state.config,
      userInfo: state => state.loginInfo,
      tabConfig: state => state.tabConfig
    }),
    firstWord() {
      const userInfo = this.userInfo.firstName || this.userInfo.email || '';
      if (userInfo[0]) {
        return userInfo.substring(0, 1);
      }
      return '';
    },
    openUsagePage() {
      const usageServiceUrl = this.config.urlInfo.usageServiceUrl + '/?type=partyline&email=' + this.State.loginInfo.email + '&partycode=' + this.State.partyCode;
      return usageServiceUrl;
    }
  },
  methods: {
    getBackendVersion() {
      this.axios.get('/partyline-backend/publicApi/debug/version').then(res => {
        if (!res) return;
        const {
          errorCode
        } = res.data;
        let {
          result
        } = res.data;
        if (errorCode === '0x0') {
          handleLocalStorage('set', 'backendVersion', result);
          if (result && result.includes('_')) {
            result = result.substring(0, result.indexOf('_'));
          }
          this.backendVersion = result;
        }
      });
    },
    topHeaderCallback(info) {
      const {
        type
      } = info;
      if (type === 'signOut') {
        this.logout();
      }
    },
    returnStyle(info) {
      return `color: #282823;position:absolute;z-index:10!important;top: ${info.y}px;left: ${info.x}px`;
    },
    saveModule(item) {
      this.currentModule = item.name;
      this.State.currentModule = this.currentModule;
      gtag('event', 'manage selectModule', {
        event_category: 'click',
        event_label: '选择会议模块',
        value: this.currentModule
      });
    },
    showReceivedPop() {
      this.showRightPop = false;
      this.State.receivedCohost = true;
    },
    getName() {
      const userInfo = this.userInfo;
      if (userInfo.firstName && userInfo.lastName) {
        return userInfo.firstName + ' ' + userInfo.lastName;
      } else if (userInfo.userName) {
        return userInfo.userName;
      } else {
        return userInfo.email ? userInfo.email.split('@')[0] : '';
      }
    },
    changeLanguage(lang) {
      Cookie.set('userLanguage', lang, {
        domain: '.tvunetworks.com'
      });
      this.$i18n.locale = lang;
      this.State.browserLanguage = lang;
    },
    // 协作功能代码开始
    showCollaborate() {
      this.collaborateInfo.show = true;
    },
    getInvitedList(tab) {
      if (!tab || tab.name === 'invitedOther' || this.selectType === 'invitedOther') {
        this.collaboratePageInfo.pageNum = 1;
        this.collaborateInfo.hideSave = true;
        this.getCollaborateHadInvite('init');
      } else {
        this.receiverCollaboratePageInfo.pageNum = 1;
        this.collaborateInfo.hideSave = true;
        this.getInvitedByOther('init');
      }
    },
    async getCollaborateHadInvite(init) {
      if (!init && !this.collaboratePageInfo.hasNextPage) return;
      // 如果init没有则是滚动加载进来的页数要加1
      if (!init) this.collaboratePageInfo.pageNum++;
      // 清空之前的状态
      this.collaborateSearchName = '';
      this.showErrorEmailText = false;
      this.willInviteCollaborate = [];
      if (this.collaboratePageInfo.pageNum == 1) {
        this.hadInvite = [];
      }
      const params = {
        invite: true,
        queryCollaborate: true,
        pageSize: this.collaboratePageInfo.pageSize,
        pageNum: this.collaboratePageInfo.pageNum
      };
      await this.axios.post('/partyline-backend/collaborate/queryV2', params).then(res => {
        if (!res) return;
        const {
          errorCode,
          result
        } = res.data;
        if (errorCode === '0x0') {
          this.collaboratePageInfo.hasNextPage = result.hasNextPage;
          if (this.collaboratePageInfo.pageNum == 1) {
            const hadInviteArray = [];
            result.list.forEach((info, index) => {
              if (index < 3) {
                info.color = this.returnColor(info);
                hadInviteArray.push(info.collaborateEmail.slice(0, 1));
              }
            });
            this.hadInvite = hadInviteArray;
          }
          if (!init) {
            this.hadInviteCollaborate = this.hadInviteCollaborate.concat(result.list);
            this.State.hadInvitedList = this.hadInviteCollaborate.concat(JSON.parse(JSON.stringify(result.list)));
          } else {
            this.hadInviteCollaborate = result.list;
            this.State.hadInvitedList = JSON.parse(JSON.stringify(result.list));
          }
          // this.hadInviteCollaborate = result
          // this.State.hadInvitedList = JSON.parse(JSON.stringify(result))
        } else {
          this.$message.warning(res.data.errorInfo);
        }
      });
    },
    getInvitedByOther(init) {
      if (!init && !this.receiverCollaboratePageInfo.hasNextPage) return;
      // 如果init没有则是滚动加载进来的页数要加1
      if (!init) this.receiverCollaboratePageInfo.pageNum++;
      const params = {
        invite: false,
        queryCollaborate: true,
        pageSize: this.receiverCollaboratePageInfo.pageSize,
        pageNum: this.receiverCollaboratePageInfo.pageNum
      };
      this.axios.post('/partyline-backend/collaborate/queryV2', params).then(res => {
        if (!res) return;
        const {
          errorCode,
          result
        } = res.data;
        if (errorCode === '0x0') {
          this.receiverCollaboratePageInfo.hasNextPage = result.hasNextPage;
          result.list.forEach(item => {
            item.select = '';
            item.color = this.returnColor(item);
          });
          if (!init) {
            this.invitedMeList = this.invitedMeList.concat(result.list);
          } else {
            this.invitedMeList = result.list;
          }
        } else {
          this.$message.warning(res.data.errorInfo);
        }
      });
    },
    saveCollaborate(email) {
      if (!this.collaborateSearchName) {
        this.$message.warning(this.$t('personalInfo.noInvitedEmail'));
        this.collaborateInfo.show = true;
        return false;
      }
      if (this.selectType != 'invitedOther') return;
      if (!this.isEmail(this.collaborateSearchName)) return;
      if (this.collaborateSearchName === this.State.loginInfo.email) {
        this.$message.warning(this.$t('personalInfo.forbidSetting'));
        return;
      }
      if (this.isHadInvited(this.collaborateSearchName)) return;
      const params = {
        collaborateUserEmailList: [this.collaborateSearchName]
      };
      this.axios.post('/partyline-backend/collaborate', params, {
        errorTip: false
      }).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          if (email && this.collaborateSearchName && this.isEmail(this.collaborateSearchName) && !this.isHadInvited(this.collaborateSearchName)) {
            const obj = {};
            obj.name = this.collaborateSearchName;
            obj.color = 'gray';
            this.willInviteCollaborate.push(obj);
          }
          this.willInviteCollaborate = [...new Set(this.willInviteCollaborate)];
          this.collaborateSearchName = '';
          this.getCollaborateHadInvite();
          this.$message.success(this.$t('personalInfo.hostSaveSuccess'));
          // 关闭弹窗
          this.collaborateInfo.show = false;
        } else if (errorCode === '9000002') {
          this.$message.warning(this.$t('personalInfo.forbidSetting'));
        } else {
          this.$message.warning(res.data.errorInfo);
        }
      });
    },
    // 判断是否已经存在于列表中(协作)
    isHadInvited(email) {
      let flag = false;
      this.willInviteCollaborate.forEach(item => {
        if (item.name == email) {
          flag = true;
        }
      });
      this.hadInviteCollaborate.forEach(info => {
        if (info.collaborateEmail == email && info.status != 2) {
          flag = true;
        }
      });
      if (flag) {
        this.$message.warning(this.$t('personalInfo.hadInvited'));
      }
      return flag;
    },
    removeCollaborateInvite(index) {
      this.willInviteCollaborate.splice(index, 1);
    },
    deleteCollaborateInvite(userId, index) {
      const params = {
        userIds: [userId]
      };
      this.axios.delete('/partyline-backend/collaborate', {
        data: params
      }).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          const _this = this;
          if (_this.collaboratePageInfo.pageNum == 1 && _this.collaboratePageInfo.hasNextPage) {
            this.getCollaborateHadInvite('init');
          } else {
            this.hadInviteCollaborate.splice(index, 1);
            this.State.hadInvitedList.splice(index, 1);
          }
          if (_this.collaboratePageInfo.pageNum == 1) {
            this.hadInvite.splice(index, 1);
          }
          this.$message.success(this.$t('invite.inviteDeleteSuccess'));
        } else {
          this.$message.warning(res.data.errorInfo);
        }
      });
    },
    showInvitedTime(invitedTime) {
      const year = new Date(invitedTime).getFullYear();
      let month = new Date(invitedTime).getMonth() + 1;
      let date = new Date(invitedTime).getDate();
      if (month < 10) {
        month = '0' + month;
      }
      if (date < 10) {
        date = '0' + date;
      }
      return year + '-' + month + '-' + date;
    },
    returnText(rowInfo) {
      let _str = '';
      if (rowInfo.status == 0) {
        _str = this.$t('personalInfo.inviting');
      } else if (rowInfo.status == 1) {
        _str = this.$t('personalInfo.accept');
      } else {
        _str = this.$t('personalInfo.declined');
      }
      return _str;
    },
    isEmail(val) {
      var regEmail = /^([a-zA-Z0-9_\-\.])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      if (val && !regEmail.test(val)) {
        this.showErrorEmailText = true;
        this.$refs.emailInput.$el.children[0].focus();
        return false;
      }
      return true;
    },
    returnColor(info) {
      const {
        status
      } = info;
      if (status === 0 || status === 2) {
        return 'gray';
      } else if (status === 1) {
        return this.hadInviteUserColor[info.collaborateEmail.length % 4] || 'green';
      }
    },
    returnMouseColor(email) {
      return this.hadInviteUserColor[email.length % 4] || 'green';
    },
    checkInputText(val) {
      if (this.inputTimer) clearTimeout(this.inputTimer);
      const _this = this;
      this.inputTimer = setTimeout(() => {
        var regEmail = /^([a-zA-Z0-9_\-\.])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
        if (val && !regEmail.test(val)) {
          this.showErrorEmailText = true;
          _this.$refs.emailInput.$el.children[0].focus();
        } else {
          this.showErrorEmailText = false;
        }
      }, 800);
    },
    controlPermission(val, rowInfo) {
      const params = {
        collaborateId: rowInfo.id,
        optionType: Number(val)
      };
      this.axios.post(`/partyline-backend/collaborate/updateStatusDirectly?collaborateId=${params.collaborateId}&optionType=${params.optionType}`, params).then(res => {
        if (res.data.errorCode == '0x0') {
          this.invitedMeList.forEach(item => {
            if (item.userId == rowInfo.userId) {
              item.status = params.optionType;
              item.color = this.returnColor({
                status: params.optionType,
                collaborateEmail: item.userEmail
              });
            }
          });
          this.$message.success(this.$t('commonFunction.operateSuccessful'));
        }
      });
    },
    deleteCollaborateByOtherInvite(rowInfo) {
      const params = {
        userIds: [rowInfo.userId],
        invite: false
      };
      this.axios.delete('/partyline-backend/collaborate', {
        data: params
      }).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          if (this.receiverCollaboratePageInfo.pageNum == 1 && this.receiverCollaboratePageInfo.hasNextPage) {
            this.getInvitedByOhter('init');
          } else {
            this.invitedMeList.forEach((item, index) => {
              if (item.userId == rowInfo.userId) {
                this.invitedMeList.splice(index, 1);
              }
            });
          }
          this.$message.success(this.$t('invite.inviteDeleteSuccess'));
        } else {
          this.$message.warning(res.data.errorInfo);
        }
      });
    },
    closeCollaborate() {
      this.collaboratePageInfo.pageNum = 1;
      this.receiverCollaboratePageInfo.pageNum = 1;
    },
    // 协作功能代码结束
    logout() {
      this.axios.get('/partyline-backend/user/logout').then(res => {
        if (!res) return;
        if (res.data.errorCode == '0x0') {
          this.$store.commit('jumpLoginPage');
        }
      });
    }
  }
};